import { api, adminApi, productApi, orderApi } from '../../services/api';

// Helper function for error handling
const handleApiError = (error) => {
  const message = error.response?.data?.message || error.message || 'An error occurred';
  const statusCode = error.response?.status;
  
  if (statusCode === 401) {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    window.location.href = '/login';
  }
  
  throw new Error(message);
};

// API Service for Admin Panel - Using unified api instance
export const apiService = {
  // Products
  getProducts: async (params = {}) => {
    try {
      const response = await productApi.list({ limit: 200, ...params });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  createProduct: async (data) => {
    try {
      const response = await productApi.create(data);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  updateProduct: async (id, data) => {
    try {
      const response = await productApi.update(id, data);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  deleteProduct: async (id) => {
    try {
      const response = await productApi.delete(id);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  // Orders
  getOrders: async () => {
    try {
      const response = await api.get('/orders');
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getOrderById: async (id) => {
    try {
      const response = await api.get(`/orders/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  updateOrderStatus: async (id, status) => {
    try {
      const response = await api.patch(`/orders/${id}/status`, { status });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  // Customers
  getCustomers: async () => {
    try {
      const response = await api.get('/admin/customers');
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  // Analytics/Dashboard
  getAnalytics: async () => {
    try {
      const response = await adminApi.dashboard();
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getDashboard: async () => {
    try {
      const response = await adminApi.dashboard();
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  // Upload image
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.post('/upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }
};
